import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { DeptUserPicker } from "@/components/work/WorkParts";

const EMPTY = { sku: "", quantity: "", reason: "", department: "", responsible_user_id: "" };

export default function QcTab({ onChanged }) {
  const [form, setForm] = useState(EMPTY);
  const [departments, setDepartments] = useState([]);
  useEffect(() => { api.get("/rbac/departments").then((r) => setDepartments(r.data)).catch(() => {}); }, []);

  const act = async (endpoint, label) => {
    if (endpoint === "qc-hold" && (!form.department || !form.responsible_user_id)) {
      toast.error("Select the department and responsible user for this QC hold"); return;
    }
    try {
      const r = await api.post(`/stock/${endpoint}`, { sku: form.sku, quantity: parseInt(form.quantity) || 0, reason: form.reason,
        department: form.department || null, responsible_user_id: form.responsible_user_id || null });
      toast.success(`${label} — free stock now ${r.data.free}`);
      setForm(EMPTY);
      onChanged?.();
    } catch (e) { toast.error(String(e.response?.data?.detail || "Failed")); }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 space-y-3" data-testid="qc-tab">
      <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">
        QC Hold = quarantine (excluded from free stock). Reject writes stock off from physical.
      </p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
        <Input placeholder="SKU" value={form.sku} onChange={(e) => setForm({ ...form, sku: e.target.value })} data-testid="qc-sku" />
        <Input type="number" placeholder="Qty" value={form.quantity} onChange={(e) => setForm({ ...form, quantity: e.target.value })} data-testid="qc-qty" />
        <div className="col-span-2"><Input placeholder="Reason" value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} data-testid="qc-reason" /></div>
      </div>
      <div className="grid grid-cols-2 gap-2 p-3 rounded-md border border-primary/30 bg-primary/5" data-testid="qc-owner-block">
        <div>
          <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground mb-1">Department (hold owner) *</p>
          <select className="h-9 rounded-md border border-input bg-background px-2 text-xs w-full" value={form.department} data-testid="qc-department-select"
            onChange={(e) => setForm({ ...form, department: e.target.value, responsible_user_id: "" })}>
            <option value="">Select department…</option>
            {departments.map((d) => <option key={d.name} value={d.name}>{d.name}</option>)}
          </select>
        </div>
        <div>
          <p className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground mb-1">Responsible user *</p>
          <DeptUserPicker department={form.department} value={form.responsible_user_id} onChange={(v) => setForm({ ...form, responsible_user_id: v })} testid="qc-responsible-user" />
        </div>
      </div>
      <div className="flex gap-2 flex-wrap">
        <Button variant="outline" onClick={() => act("qc-hold", "Held")} data-testid="qc-hold-btn">Hold</Button>
        <Button variant="outline" onClick={() => act("qc-release", "Released")} data-testid="qc-release-btn">Release</Button>
        <Button variant="outline" className="text-signal-red border-signal-red/40" onClick={() => act("qc-reject", "Rejected")} data-testid="qc-reject-btn">Reject</Button>
      </div>
    </div>
  );
}
